export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9974.3b7670bd.jpg";